import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTableData,
  fetchGPUData,
  getDistinctDataThroughSingleApi,
  fetchRegionData
} from "../actions/actions";


const ptuTableDataState = {
  tableData: [],
  isTableDataLoading: true,
  isTableDataLoaded: false,
  isTableDataError: null,
};

export const tableDataReducer = createSlice({
  name: "tableData",
  initialState: ptuTableDataState,
  reducers: {
    updateAllManagedTableData(state, action) {
      const { payload } = action;
      return {
        ...state,
        tableData: payload,
      };
    },
    updateTableDataByRequestId(state, action) {
      const { requestId, updatedObject } = action.payload;
      state.tableData = state.tableData.map((item) => {
        if (item.RequestID === requestId) {
          return updatedObject;
        }
        return item;
      });
    },
    updatePropertyOfSelectedSetInputByRequestId(state, action) {
      const { requestId, propertyValue, label } = action.payload;
      state.tableData = state.tableData.map((item) => {
        if (item.RequestID === requestId) {
          return { ...item, [label]: propertyValue };
        }
        return item;
      });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTableData.pending, (state) => {
      state.isTableDataLoading = true;
    });
    builder.addCase(fetchTableData.fulfilled, (state, action) => {
      state.tableData = [...action.payload.data];
      state.isTableDataLoading = false;
      state.isTableDataLoaded = true;
    });
    builder.addCase(fetchTableData.rejected, (state, action) => {
      state.isTableDataLoading = false;
      state.isTableDataError = action.error.message;
    });
  },
});

const managedUnchangedTableData = {
  unchangedTableData: [],
  isTableDataLoading: true,
  isTableDataLoaded: false,
  isTableDataError: null,
};
export const UnchangedTableDataReducer = createSlice({
  name: "unchangedTableData",
  initialState: managedUnchangedTableData,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchTableData.pending, (state) => {
      state.isTableDataLoading = true;
    });
    builder.addCase(fetchTableData.fulfilled, (state, action) => {
      state.unchangedTableData = [...action.payload.data];
      state.isTableDataLoading = false;
      state.isTableDataLoaded = true;
    });
    builder.addCase(fetchTableData.rejected, (state, action) => {
      state.isTableDataLoading = false;
      state.isTableDataError = action.error.message;
    });
  },
});

export const {
  updateAllManagedTableData,
  updateTableDataByRequestId,
  updatePropertyOfSelectedSetInputByRequestId,
} = tableDataReducer.actions;


const distinctDataThroughSingleApiState = {
  distinctDataThroughSingleApi: {},
  isDistinctDataThroughSingleApiLoading: true,
  distinctDataThroughSingleApiError: null,
  isDistinctDataThroughSingleApiLoaded: false,
};

export const distinctDataThroughSingleApiReducer = createSlice({
  name: "distinctDataThroughSingleApi",
  initialState: distinctDataThroughSingleApiState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDistinctDataThroughSingleApi.pending, (state) => {
      state.isDistinctDataThroughSingleApiLoading = true;
    });
    builder.addCase(getDistinctDataThroughSingleApi.fulfilled, (state, action) => {
      state.isDistinctDataThroughSingleApiLoading = false;
      state.isDistinctDataThroughSingleApiLoaded = true;
      state.distinctDataThroughSingleApi = action.payload.data;
    });
    builder.addCase(getDistinctDataThroughSingleApi.rejected, (state, action) => {
      state.isDistinctDataThroughSingleApiLoading = false;
      state.distinctDataThroughSingleApiError = action.distinctDataError.message;
    });
  },
});

const regionDataState = {
  regionData: {},
  isRegionDataLoading: true,
  regionDataError: null,
  isRegionDataLoaded: false,
};

export const regionDataReducer = createSlice({
  name: "regionData",
  initialState: regionDataState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchRegionData.pending, (state) => {
      state.isRegionDataLoading = true;
    });
    builder.addCase(fetchRegionData.fulfilled, (state, action) => {
      state.isRegionDataLoading = false;
      state.isRegionDataLoaded = true;
      state.regionData = action.payload.data;
    });
    builder.addCase(fetchRegionData.rejected, (state, action) => {
      state.isRegionDataLoading = false;
      state.regionDataError = action.error.message;
    });
  },
});

const GPUState = {
  GPUData: [],
  gpuWiseRegionData: {},
  isGPUDataLoading: false,
  isGPUDataLoaded: false,
  GPUDataError: null,
};
 
export const GPUReducer = createSlice({
  name: "fetchGPUData",
  initialState: GPUState,
  reducers: {
    handleManualAllocation(state, action) {
      const { oldObject , newObject} = action.payload;
      if (!oldObject) {
        return state;
      }
      const regionGranted = oldObject['DC_RegionAllocated'];
      const gpu_name = oldObject['GPU_Name']
      const requestStatus = oldObject['RequestStatus'];
      const GPU_Granted = oldObject['GPUsAllocated'];
      const newRegionGranted = newObject['DC_RegionAllocated'];
      const newRequestStatus = newObject['RequestStatus'];
      const newGpu_name = newObject['GPU_Name']
      const newGPU_Granted = newObject['GPUsAllocated'];
      if(gpu_name && regionGranted && (GPU_Granted !=="")){
        state.GPUData ={
          ...state.GPUData,
          [gpu_name]: state.GPUData[gpu_name].map(element => {
            const plainElement = { ...element };
            if (plainElement.Region === regionGranted) {
              if(requestStatus === "Earmarked"){
                const gpusinState = plainElement.GPUsEarmarked;
                const newValue = gpusinState - parseInt(GPU_Granted)
                return {
                  ...element,
                  GPUsEarmarked: newValue,
                  GPUsAvailable: plainElement.Total - (newValue + plainElement.GPUsAllocated + plainElement.GPUsCommitted)
                };
              }
              else if(requestStatus === "Committed"){
                const gpusinState = parseInt(plainElement.GPUsCommitted, 10);
                const newValue = gpusinState - parseInt(GPU_Granted)
                return {
                  ...element,
                  GPUsCommitted:newValue,
                  GPUsAvailable: plainElement.Total - (newValue + plainElement.GPUsAllocated + plainElement.GPUsEarmarked)
                };
              }else if(requestStatus === "Fully Allocated" || requestStatus === "Partially Allocated"){
                const gpusinState = parseInt(plainElement.GPUsAllocated, 10);
                const newValue = gpusinState - parseInt(GPU_Granted)
                return {
                  ...element,
                  GPUsAllocated: newValue,
                  GPUsAvailable: plainElement.Total - (newValue + plainElement.GPUsCommitted + plainElement.GPUsEarmarked)
                };
              }else if(requestStatus === "Lost" ||  
                requestStatus === "Returned" ||
                requestStatus === "Cancelled" ||
                requestStatus === "On Hold"){
                return {
                  ...element,
                  GPUsAvailable: plainElement.Total - (plainElement.GPUsAllocated + plainElement.GPUsCommitted + plainElement.GPUsEarmarked) 
                 
                };
              }
             
            }
            return element;
          })
      };
      }
      if(newGpu_name  &&  newRegionGranted){
        state.GPUData ={
          ...state.GPUData,
          [newGpu_name]: state.GPUData[newGpu_name].map(element => {
            const plainElement = { ...element };
            if (plainElement.Region === newRegionGranted) {
              if(newRequestStatus === "Earmarked"){
                const gpusinState = plainElement.GPUsEarmarked;
                const newValue = gpusinState + parseInt(newGPU_Granted)
                return {
                  ...element,
                  GPUsEarmarked: newValue,
                  GPUsAvailable: plainElement.Total - (newValue + plainElement.GPUsAllocated + plainElement.GPUsCommitted)
                };
              }
              else if(newRequestStatus === "Committed"){
                const gpusinState = parseInt(plainElement.GPUsCommitted, 10);
                const newValue = gpusinState + parseInt(newGPU_Granted)
                return {
                  ...element,
                  GPUsCommitted:newValue,
                  GPUsAvailable: plainElement.Total - (newValue + plainElement.GPUsAllocated + plainElement.GPUsEarmarked)
                };
              }else if(newRequestStatus === "Fully Allocated" || newRequestStatus === "Partially Allocated"){
                const gpusinState = parseInt(plainElement.GPUsAllocated, 10);
                const newValue = gpusinState + parseInt(newGPU_Granted)
                return {
                  ...element,
                  GPUsAllocated: newValue,
                  GPUsAvailable: plainElement.Total - (newValue + plainElement.GPUsCommitted + plainElement.GPUsEarmarked)
                };
              }else if(newRequestStatus === "Lost" ||  
                newRequestStatus === "Returned" ||
                newRequestStatus === "Cancelled" ||
                newRequestStatus === "On Hold"){
                return {
                  ...element,
                  GPUsAvailable: plainElement.Total - (plainElement.GPUsEarmarked + plainElement.GPUsAllocated + plainElement.GPUsCommitted)
                 
                };
              }
             
            }
            return element;
          })
      };
      }
     

    },
    updateGPUData(state,action){
      const { object , transaction} = action.payload;
      state.GPUData ={
        ...state.GPUData,
        [object.GPU_Name]: state.GPUData[object.GPU_Name].map(element => {
          const plainElement = { ...element };
          if (plainElement.Region === object.DC_RegionAllocated) {
            if(parseInt(object.GPUsAllocated)){
              return {
                ...element,
                GPUsAvailable: transaction === "add" ? (plainElement.GPUsAvailable + parseInt(object.GPUsAllocated)) : (plainElement.GPUsAvailable - parseInt(object.GPUsAllocated))
              };
             
            }
           
          }
          return element;
        })
    };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchGPUData.pending, (state) => {
      state.isGPUDataLoading = true;
    });
    builder.addCase(fetchGPUData.fulfilled, (state, action) => {
      state.isGPUDataLoading = false;
      state.isGPUDataLoaded = true;
      const gpuData = action.payload.data
      let gpuWiseData ={}
      Object.entries(gpuData).forEach(([gpuname, regionObject]) => {
        regionObject.forEach(gpuObject => {
          if (!gpuWiseData[gpuname]) {
            gpuWiseData[gpuname] = [];
          }
          gpuWiseData[gpuname].push(gpuObject.Region);
        });
      });
      state.GPUData = gpuData;
      state.gpuWiseRegionData = gpuWiseData
    });
    builder.addCase(fetchGPUData.rejected, (state, action) => {
      state.isGPUDataLoading = false;
      state.GPUDataError = action.error.message;
    });
  },
});
 
export const { handleManualAllocation, updateGPUData } = GPUReducer.actions;

